import React, { Component } from 'react'
import './Body.scss'
import { leadID } from "../Services/fetchService";
import { DomField, DomSelect, DomBoolCheckbox, DomTextarea, DomDate } from "../Services/formDOM";
import { checkInput, returnValue } from "../Services/Validation";
import { GA_Push } from "../Services/GoogleAnalytics";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import { mobile } from '../Services/Agent';
// import "whatwg-fetch";


export default class Form extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            isBusy: false,
            isLoading: false,
            // isLoading: true,
            pageStyle: "form",
            // pageStyle: "sent",
            // pageStyle: "done",
            FileName: {
                value: "",
                name: "FileName",
                error: "",
                alreadySent: false,
                isRequired: false,
                shouldValidate: false,
                ImagePlaceholder: "אנא צרפו תמונה של המשפחה"
            },
            captchaEnable: !Environment().isLocalhost
        };
        window.sendCallback = this.sendForm;
    }

    componentDidMount() {
        if(localStorage.getItem('alreadySent')){
            this.setState({pageStyle : "sent"})
            return;
        }
        (() => {
            if (window.document.getElementById("GoogleRecap")) return;

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.id = "GoogleRecap";
            script.async = 1;
            script.defer = 1;
            script.src = "https://www.google.com/recaptcha/api.js";

            document.getElementsByTagName("head")[0].appendChild(script);
        })();
    }

    addState = (stateName, isRequired, shouldValidate) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                isRequired: !isRequired ? false : true,
                shouldValidate: !shouldValidate ? false : true
            }
        });
    };

    handleInputChange = event => {
        if(event.target.value.length > 1220)return;
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                value:
                    event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value
            }
        });
    };

    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
    };

    openModal = () => this.setState({ isOpen: true });

    setPage = pageStyle =>
        this.setState({
            pageStyle: pageStyle
        });

    checkString = event => {
        let { name, value } = event.target;
        switch (name) {
            default:
                return value;
        }
    };

    onlyLetters = string => string.replace(/[0-9]/i, "");

    onlyNumbers = string => string.replace(/[+\\/!*@#$%^&a-zA-Z\-\u0590-\u05FF]/i, "");

    changeImageLabel = event => {
        var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
        var file = event.target.files[0];
        if (file) {
            if (file.size > 5242880) {
                alert("לא ניתן להעלות קבצים מעל 5mb");
                event.target.value = "";
                return false;
            }

            var isAllowd = false;
            allowdExtensions.forEach(extension => {
                if (file.type.indexOf(extension) > -1) {
                    isAllowd = true;
                }
            });

            if (!isAllowd) {
                alert("ניתן לעלות רק קבצי תמונה");
                event.target.value = "";
                return false;
            }

            this.setState({
                FileName: {
                    ...this.state.FileName,
                    name: file.name,
                    value: file,
                    error: "",
                    label: "",
                    ImagePlaceholder: file.name,
                    id: "FileName"
                }
            });
        } else {
            return false;
        }
    };

    saveAndValidate = async () => {
        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true,
            alreadySent: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            stateValidate = Object.filter(this.state, s => s.shouldValidate),
            state = Object.filter(this.state, s => s.isRequired),
            fieldstateValidateKeys = Object.keys(stateValidate),
            fieldStateKeys = Object.keys(state);

        for (let s in stateValidate) {
            if (await !checkInput(stateValidate[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldstateValidateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            });
            return;
        }
        console.log(this.state)
        this.setState(
            {
                jsonBody,
                isLoading: true,
                isBusy: true
            },
            () => (this.state.captchaEnable ? window.grecaptcha.execute() : this.sendForm())
        );
    };

    sendForm = async () => {
        let formData = new FormData();
        let formDataEmailPhone = new FormData();
        const { jsonBody } = this.state;

        formData.append("LeadID", leadID.toString());
        // formDataEmailPhone.append("LeadID", leadID.toString());
        for (let k = 0; k < Object.keys(jsonBody).length; k++) {
            let _key = Object.keys(jsonBody)[k];
            formData.append(_key, jsonBody[_key]);
            if (_key == "PhoneNumber" || _key == "Email") {
                formDataEmailPhone.append(_key, jsonBody[_key]);
            }
        }

        // if (this.state.captchaEnable) {
        //     window.grecaptcha.reset()
        // }

        this.state.captchaEnable && window.grecaptcha.reset();
        localStorage.setItem('alreadySent', true)
        fetch(`${apiURL}Save`, {
            method: "POST",
            body: formData
        })
            .then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false,
                    pageStyle: "done"
                });
                GA_Push("Form_Events", "Form Submission", "Success", "Forms");
                // GA_Push("GA_Events", "form_sent");
                if (this.state.captchaEnable) {
                    window.grecaptcha.reset();
                }
            })
            .catch(error => {
                GA_Push("Form_Events", "Form Submission", "Fail", "Forms");
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
            });
    };
    render() { 
        console.log(mobile())
        return (
            <section className={`section-form ${this.state.pageStyle}`} >
                <div className="wrapper">
                    <div className="flex-container">
                        <div className='desktop-flex'>
                            <div className='name-birthdate'>
                                <DomField
                                    type="text"
                                    max={64}
                                    label="שם מלא"
                                    placeholder="שם מלא"
                                    name="FullName"
                                    id="FullName"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                {!mobile() ?
                                <DomDate
                                    type="text"
                                    max={64}
                                    label="תאריך לידה"
                                    placeholder="תאריך לידה :       שנה  /  חודש  /  יום"
                                    name="ExtraField2"
                                    id="ExtraField2"
                                    className="birthday"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                :
                                <DomField
                                    type="date"
                                    max={64}
                                    label="תאריך לידה"
                                    placeholder="תאריך לידה :       שנה  /  חודש  /  יום"
                                    name="ExtraField2"
                                    id="ExtraField2"
                                    className="birthday"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                }
                            </div>
                            <div className="address-gender">
                                <DomSelect
                                    placeholder="מין"
                                    name="Gender"
                                    id="Gender"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                <DomField
                                    type="text"
                                    max={100}
                                    label="כתובת/עיר מגורים"
                                    placeholder="כתובת/עיר מגורים"
                                    name="PlainText2"
                                    id="PlainText2"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                            </div>
                        </div>
                        <div className="witch-sport">
                            <div className='mail-phone'>
                                <DomField
                                    type="text"
                                    max={64}
                                    label="מייל"
                                    placeholder="מייל"
                                    name="Email"
                                    id="Email"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                <DomField
                                    type="tel"
                                    max={100}
                                    label="טלפון"
                                    placeholder="טלפון"
                                    name="PhoneNumber"
                                    id="PhoneNumber"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                </div>
                            <DomField
                                type="text"
                                max={64}
                                label="ענף ספורט"
                                placeholder="ענף בו תרצה/י להיבחן (כדורגל/כדורסל/ריצה קצרה)"
                                name="ExtraField1"
                                id="ExtraField1"
                                isRequired
                                shouldValidate
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state}
                                />
                            </div>
                            <DomTextarea
                                _settings={{
                                    maxLength: 1220
                                }}
                                className="why-input"
                                type="text"
                                label="הערות"
                                placeholder="ספר/י לנו קצת על עצמך, האם את/ה מתאמנ/ת בקבוצה כלשהי כרגע? (כמה שנים מתאמנ/ת , הישגים יוצאי דופן בענף, השתתפות בתחרויות כלשהן ועוד) עד 250 מילים"
                                name="PlainText"
                                id="PlainText"
                                className=""
                                isRequired
                                shouldValidate
                                onChange={this.handleInputChange}
                                onLoad={this.addState}
                                {...this.state} />
                    </div>
                    <div className="terms">
                        <Loading showLoading={this.state.isLoading} />
                        <div className="">
                            <div className="checkbox">
                                <div className="check-wrapper">
                                <DomBoolCheckbox
                                    label="אני מאשר/ת שאינני שחקן/ית פעיל/ה בליגה הראשונה. "
                                    type="checkbox"
                                    name="noPro"
                                    id="noPro"
                                    isRequired
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                <DomBoolCheckbox
                                    label={`אני שולח/ת בהסכמת הוריי/אפוטרופוסי, את פרטיי ותשובתי לפי <a href=${`https://z.ynet.co.il/mShort/generics/Leads/TOS/${leadID}/`} target="_blank">התקנון</a> ומאשר/ת קבלת פרסום לפי <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html`} target="_blank">תנאי השימוש</a> ו-<a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html`} target="_blank">מדיניות הפרטיות</a>.`}
                                    type="checkbox"
                                    name="TOS"
                                    id="TOS"
                                    shouldValidate
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state}
                                />
                                </div>
                                <div
                                    className="send-button"
                                    onClick={() => {
                                        this.saveAndValidate();
                                    }}>
                                    <div
                                        className="g-recaptcha"
                                        data-callback="sendCallback"
                                        data-size="invisible"
                                        data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
